// extracted by mini-css-extract-plugin
module.exports = {"hidden":"v4Warning_hidden__xgLGz","textEmphasis":"v4Warning_textEmphasis__IXUH9","warningWrap":"v4Warning_warningWrap__wOege"};